import axios from "axios";
import _ from "lodash";

export const baseUrl = process.env.VUE_APP_HAPPYQUIZ_BASE_API;

/**
 * Global header.
 *
 * @type {{headers: {"Access-Control-Allow-Origin": string}}}
 */
export const globalHeaders = {
    headers: {
        'Access-Control-Allow-Origin': '*'
    }

};

/**
 * Config create.
 *
 * @param config
 * @returns {{headers: {"Access-Control-Allow-Origin": string}}}
 */
export const createConfig = (config) => {
    let headerConfig = globalHeaders;

    if (config) {
        headerConfig.headers = Object.assign(globalHeaders.headers, config);
    }

    return headerConfig;
}

/**
 * query build.
 *
 * @param object
 * @returns {string}
 */
export const buildQueryString = (object) => {
    let array = [];

    Object.entries(object).forEach(([key, value]) => {
        array.push(`${key}=${value}`);
    });

    return array.join('&');
}

/**
 * Send ajax request.
 *
 * @param method_type
 * @param url
 * @param data
 * @param config
 * @returns {Promise<{status_code: number, data: {remaining_time, user_id, account_exists, token: *}, success: (boolean|(function(*): (*|undefined))|*|Event), message}|{status_code: (number|*), data, success: (boolean|(function(*): (*|undefined))|*|Event), message}|{status_code: ((function(number): *)|number), data: T, success: boolean, message}|{status_code: ((function(number): *)|number), data: T, success: boolean, message: string}>}
 */
export const sendRequest = (method_type, url, data = {}, config = null) => {
    let result;

    if (method_type === 'get') {
        let query_string = Object.keys(data).length !== 0 && data.constructor === Object
            ? buildQueryString(data)
            : '';

        let final_url = query_string.length ? url + '?' + query_string : url;

        result = get(final_url, config);

    } else if (method_type === 'post') {
        result = post(url, data, config)
    } else if (method_type === 'update') {
        result = update(url, data, config)
    } else {
        result = destroy(url, config)
    }
    return result;
}

/**
 * Get method.
 *
 * @param url
 * @param config
 * @returns {Promise<{status_code: number, data: {remaining_time, user_id, account_exists, token: *}, success: (boolean|(function(*): (*|undefined))|*|Event), message} | {status_code: (number|*), data, success: (boolean|(function(*): (*|undefined))|*|Event), message} | {status_code: ((function(number): *)|number), data: T, success: boolean, message} | {status_code: ((function(number): *)|number), data: T, success: boolean, message: string}>}
 */
export const get = (url, config = null) => {
    return axios.get(baseUrl + url, createConfig(config))
        .then(response => {
            return successData(response.data);
        })
        .catch(error => {
            return errorData(error);
        })
};

/**
 * Post method.
 *
 * @param url
 * @param data
 * @param config
 * @returns {Promise<{status_code: number, data: {remaining_time, user_id, account_exists, token: *}, success: (boolean|(function(*): (*|undefined))|*|Event), message} | {status_code: (number|*), data, success: (boolean|(function(*): (*|undefined))|*|Event), message} | {status_code: ((function(number): *)|number), data: T, success: boolean, message} | {status_code: ((function(number): *)|number), data: T, success: boolean, message: string}>}
 */
export const post = (url, data, config = null) => {
    return axios.post(baseUrl + url, data, createConfig(config))
        .then(response => {

            return successData(response.data);
        })
        .catch(error => {
            return errorData(error);
        })
};

/**
 * Update method.
 *
 * @param url
 * @param data
 * @param config
 * @returns {Promise<{status_code: number, data: {remaining_time, user_id, account_exists, token: *}, success: (boolean|(function(*): (*|undefined))|*|Event), message} | {status_code: (number|*), data, success: (boolean|(function(*): (*|undefined))|*|Event), message} | {status_code: ((function(number): *)|number), data: T, success: boolean, message} | {status_code: ((function(number): *)|number), data: T, success: boolean, message: string}>}
 */
export const update = (url, data, config = null,) => {
    return axios.put(baseUrl + url, data, createConfig(config))
        .then(response => {
            return successData(response.data);
        })
        .catch(error => {
            return errorData(error);
        })
};

/**
 * Destroy Method.
 *
 * @param url
 * @param config
 * @returns {Promise<{status_code: number, data: {remaining_time, user_id, account_exists, token: *}, success: (boolean|(function(*): (*|undefined))|*|Event), message} | {status_code: (number|*), data, success: (boolean|(function(*): (*|undefined))|*|Event), message} | {status_code: ((function(number): *)|number), data: T, success: boolean, message} | {status_code: ((function(number): *)|number), data: T, success: boolean, message: string}>}
 */
export const destroy = (url, config = null) => {

    return axios.delete(baseUrl + url, createConfig(config))
        .then(response => {
            return successData(response.data);
        })
        .catch(error => {
            return errorData(error);
        })
};

/**
 * Success data response.
 *
 * @param data
 * @returns {{status_code: number, data: {remaining_time, user_id, account_exists, token: *}, success: (boolean|(function(*): (*|undefined))|*|(function(*): (*|undefined))|Event), message}|{status_code: (number|*), data, success: (boolean|(function(*): (*|undefined))|*|(function(*): (*|undefined))|Event), message}}
 */
export const successData = (data) => {
    if (_.has(data, 'login') || _.has(data, 'register')) {
        return {
            status_code: 200,
            success: data.success,
            message: data.message,
            data: {
                'token': data.access_token,
                'user_id': data.user_id,
                'account_exists': data.account_exists,
                'remaining_time': data.remaining_time
            }
        }
    }
    if (_.has(data, 'title')) {
        return {
            status_code: 200,
            success: true,
            message: 'Successfully data import',
            data: data
        }
    }
    if (_.has(data, 'settings')) {
        return {
            status_code: 200,
            success: true,
            message: 'Successfully data import',
            data: data
        }
    }
    if (_.has(data, 'promotion_type')) {
        return {
            status_code: 200,
            success: data.success,
            message: 'Successfully data get',
            data: data.promotions,
        }
    }
    if (_.has(data, 'user_profile')) {
        return {
            status_code: 200,
            success: true,
            message: 'Successfully data get',
            data: data,
        }
    }
    if (_.has(data, 'today')) {
        return {
            status_code: 200,
            success: true,
            message: 'Successfully data get',
            data: data,
        }
    }
    if (_.has(data, 'response_data')) {
        return {
            status_code: 200,
            success: true,
            message: 'Successfully data get',
            data: data,
        }
    }
    if (_.has(data, 'categories')) {
        return {
            status_code: 200,
            success: true,
            message: 'Successfully data get',
            data: data,
        }
    }
    if (_.has(data, 'expected_response')) {
        return {
            status_code: 200,
            success: true,
            message: 'Successfully data get',
            data: data,
        }
    }
    if (_.has(data, 'redirectUrl')) {
        return {
            status_code: 200,
            success: true,
            message: 'Successfully data get',
            data: data,
        }
    }
    return {
        status_code: data.status_code,
        success: data.success,
        message: data.message,
        data: data.data
    }
}

/**
 * Error data response.
 *
 * @param error
 * @returns {{status_code: ((code: number) => any) | number, data: T, success: boolean, message}|{status_code: ((code: number) => any) | number, data: T, success: boolean, message: string}}
 */
export const errorData = (error) => {
    if (error.response.status === 422) {
        return {
            status_code: error.response.status,
            success: false,
            message: error.response.statusText,
            data: error.response.data
        }
    }
    return {
        status_code: error.response.status,
        success: false,
        message: error.message,
        data: error.response.data
    }
}
